export enum Environment {
  PROD = 'PROD',
  PREPROD = 'PREPROD',
  UAT2 = 'UAT2',
  UAT4 = 'UAT4',
  UAT5 = 'UAT5',
}

export class Constant {
  // Switch this to change environment easily
  public static CURRENT_ENV: Environment = Environment.UAT4;

  // Configuration per environment, grouped and ordered by application paths ascending

     
  public static origin = window.location.origin;

  private static config = {
    [Environment.PROD]: {
      BaseUrl: `${Constant.origin}/`,
    // BaseUrl: 'https://bajajallianzlifeonline.co.in/',
      RAZORPAY_KEY: 'rzp_live_X9BnXev7IfukgC',

      // BackOfficeScheduler application APIs
      createCustomer: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpaymandate/createcustomer',
      createCustomerUPI: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/createcustomerupi',
      downTimeUrl: 'https://payment.bajajlife.com/BackOfficeScheduler/util/mandate_downtime',
      renPayModeChange: 'https://payment.bajajlife.com/BackOfficeScheduler/util/updatedPayMode',
      saveMandateSign: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpaymandate/mandatesignature',
      saveMandateSignUPI: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/mandatesignatureupi',
      storeLogs: 'https://payment.bajajlife.com/BackOfficeScheduler/util/track_status',
      vendorType: 'https://payment.bajajlife.com/BackOfficeScheduler/util/mandate_pg',
      vendorTypeCCSI: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg',
      vendorTypeNACH: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg',
      vendorTypeUPI: 'https://payment.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg',


      // BalicPayment application APIs
      ccsi: 'https://payment.bajajlife.com/BalicPayment/ccsi/PG.jsp',
      NRIccsiCallbackURL: 'https://payment.bajajlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp',
      pgclCCSICallbackURL: 'https://payment.bajajlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp',
      pgclNACHCallbackURL: 'https://payment.bajajlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp',
      pgclUPICallbackURL: 'https://payment.bajajlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp',

      // CCSI application APIs
      NRIccsi: 'https://payment.bajajlife.com/CCSI/initiate/payment',
      validateSISOExtisting: 'https://payment.bajajlife.com/CCSI/mandate/validateSISOExisting',
      validateUPIAgent: 'https://payment.bajajlife.com/CCSI/mandate/validateAgentCode',
      getMandateConfig: 'https://payment.bajajlife.com/CCSI/shortenedJourney/getConfig',
       //mandate value api
      mandateAuthToken: 'https://uat3.bajajlife.com/PhysicalNachWS/api/auth/generate-token',
      authCred:{
      "username" : "uatTesting",
      "password" : "testing@123"
      },
      channelDetails:(agentCode: any) => `https://uat3.bajajlife.com/PhysicalNachWS/fetch/channels/${agentCode}`
    },

    [Environment.PREPROD]: {
      BaseUrl: `${Constant.origin}/`,
      RAZORPAY_KEY: 'rzp_test_9OoZbJ3ubvV328',

      // BackOfficeScheduler application APIs
      createCustomer: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpaymandate/createcustomer',
      createCustomerUPI: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/createcustomerupi',
      downTimeUrl: 'https://bjuat.bajajlife.com/BackOfficeScheduler/util/mandate_downtime',
      renPayModeChange: 'https://bjuat.bajajlife.com/BackOfficeScheduler/util/updatedPayMode',
      saveMandateSign: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpaymandate/mandatesignature',
      saveMandateSignUPI: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/mandatesignatureupi',
      storeLogs: 'https://bjuat.bajajlife.com/BackOfficeScheduler/util/track_status',
      vendorType: 'https://bjuat.bajajlife.com/BackOfficeScheduler/util/mandate_pg',
      vendorTypeCCSI: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg',
      vendorTypeNACH: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg',
      vendorTypeUPI: 'https://bjuat.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg',


      // BalicPayment application APIs
      ccsi: 'https://bajajuat2.bajajlife.com/BalicPayment/ccsi/PG.jsp',
      NRIccsiCallbackURL: 'https://bajajuat2.bajajlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp',
      pgclCCSICallbackURL: 'https://bajajuat2.bajajlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp',
      pgclNACHCallbackURL: 'https://bajajuat2.bajajlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp',
      pgclUPICallbackURL: 'https://bajajuat2.bajajlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp',

      // CCSI application APIs
      NRIccsi: 'https://balicpreprod.bajajlife.com/CCSI/initiate/payment',
      validateSISOExtisting: 'https://balicpreprod.bajajlife.com/CCSI/mandate/validateSISOExisting',
      validateUPIAgent: 'https://balicpreprod.bajajlife.com/CCSI/mandate/validateAgentCode',
      getMandateConfig: 'https://balicpreprod.bajajlife.com/CCSI/shortenedJourney/getConfig',
       //mandate value api
      mandateAuthToken: 'https://uat3.bajajlife.com/PhysicalNachWS/api/auth/generate-token',
      authCred:{
      "username" : "uatTesting",
      "password" : "testing@123"
      },
      channelDetails:(agentCode: any) => `https://uat3.bajajlife.com/PhysicalNachWS/fetch/channels/${agentCode}`
    },

    [Environment.UAT2]: {
     // BaseUrl: `${Constant.origin}/`,
      BaseUrl: `https://balicuat2.bajajlife.com/`,
      RAZORPAY_KEY: 'rzp_test_9OoZbJ3ubvV328',

       // BackOfficeScheduler application APIs
      createCustomer: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpaymandate/createcustomer',
      createCustomerUPI: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/createcustomerupi',
      downTimeUrl: 'https://balicuat2.bajajlife.com//BackOfficeScheduler/util/mandate_downtime',
      renPayModeChange: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/util/updatedPayMode',
      saveMandateSign: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpaymandate/mandatesignature',
      saveMandateSignUPI: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/mandatesignatureupi',
      storeLogs: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/util/track_status',
      vendorType: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/util/mandate_pg',
      vendorTypeCCSI: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg',
      vendorTypeNACH: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg',
      vendorTypeUPI: 'https://balicuat2.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg',


      // BalicPayment application APIs
      ccsi: 'https://balicuat2.bajajlife.com/BalicPayment/ccsi/PG.jsp',
      NRIccsiCallbackURL: 'https://balicuat2.bajajlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp',
      pgclCCSICallbackURL: 'https://balicuat2.bajajlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp',
      pgclNACHCallbackURL: 'https://balicuat2.bajajlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp',
      pgclUPICallbackURL: 'https://balicuat2.bajajlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp',

      // CCSI application APIs
      NRIccsi: 'https://balicuat2.bajajlife.com/CCSI/initiate/payment',
      validateSISOExtisting: 'https://balicuat2.bajajlife.com/CCSI/mandate/validateSISOExisting',
      validateUPIAgent: 'https://balicuat2.bajajlife.com/CCSI/mandate/validateAgentCode',
      getMandateConfig: 'https://balicuat2.bajajlife.com/CCSI/shortenedJourney/getConfig',

      //mandate value api
      mandateAuthToken: 'https://uat3.bajajlife.com/PhysicalNachWS/api/auth/generate-token',
      authCred:{
      "username" : "uatTesting",
      "password" : "testing@123"
      },
      channelDetails:(agentCode: any) => `https://uat3.bajajlife.com/PhysicalNachWS/fetch/channels/${agentCode}`
    },

    [Environment.UAT4]: {
      BaseUrl: `${Constant.origin}/`,
      RAZORPAY_KEY: 'rzp_test_9OoZbJ3ubvV328',

       // BackOfficeScheduler application APIs
      createCustomer: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpaymandate/createcustomer',
      createCustomerUPI: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/createcustomerupi',
      downTimeUrl: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/util/mandate_downtime',
      renPayModeChange: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/util/updatedPayMode',
      saveMandateSign: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpaymandate/mandatesignature',
      saveMandateSignUPI: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/mandatesignatureupi',
      storeLogs: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/util/track_status',
      vendorType: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/util/mandate_pg',
      vendorTypeCCSI: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg',
      vendorTypeNACH: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg',
      vendorTypeUPI: 'https://balicuat4.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg',


      // BalicPayment application APIs
      ccsi: 'https://balicuat4.bajajlife.com/BalicPayment/ccsi/PG.jsp',
      NRIccsiCallbackURL: 'https://balicuat4.bajajlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp',
      pgclCCSICallbackURL: 'https://balicuat4.bajajlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp',
      pgclNACHCallbackURL: 'https://balicuat4.bajajlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp',
      pgclUPICallbackURL: 'https://balicuat4.bajajlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp',

      // CCSI application APIs
      NRIccsi: 'https://balicuat4.bajajlife.com/CCSI/initiate/payment',
      validateSISOExtisting: 'https://balicuat4.bajajlife.com/CCSI/mandate/validateSISOExisting',
      validateUPIAgent: 'https://balicuat4.bajajlife.com/CCSI/mandate/validateAgentCode',
      getMandateConfig: 'https://balicuat4.bajajlife.com/CCSI/shortenedJourney/getConfig',
       //mandate value api
      mandateAuthToken: 'https://uat3.bajajlife.com/PhysicalNachWS/api/auth/generate-token',
      authCred:{
      "username" : "uatTesting",
      "password" : "testing@123"
      },
      channelDetails:(agentCode: any) => `https://uat3.bajajlife.com/PhysicalNachWS/fetch/channels/${agentCode}`
    },

    [Environment.UAT5]: {
      BaseUrl: `${Constant.origin}/`,
      RAZORPAY_KEY: 'rzp_test_9OoZbJ3ubvV328',

       // BackOfficeScheduler application APIs
      createCustomer: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpaymandate/createcustomer',
      createCustomerUPI: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/createcustomerupi',
      downTimeUrl: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/util/mandate_downtime',
      renPayModeChange: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/util/updatedPayMode',
      saveMandateSign: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpaymandate/mandatesignature',
      saveMandateSignUPI: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/mandatesignatureupi',
      storeLogs: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/util/track_status',
      vendorType: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/util/mandate_pg',
      vendorTypeCCSI: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg',
      vendorTypeNACH: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg',
      vendorTypeUPI: 'https://balicuat5.bajajlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg',


      // BalicPayment application APIs
      ccsi: 'https://balicuat5.bajajlife.com/BalicPayment/ccsi/PG.jsp',
      NRIccsiCallbackURL: 'https://balicuat5.bajajlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp',
      pgclCCSICallbackURL: 'https://balicuat5.bajajlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp',
      pgclNACHCallbackURL: 'https://balicuat5.bajajlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp',
      pgclUPICallbackURL: 'https://balicuat5.bajajlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp',

      // CCSI application APIs
      NRIccsi: 'https://balicuat5.bajajlife.com/CCSI/initiate/payment',
      validateSISOExtisting: 'https://balicuat5.bajajlife.com/CCSI/mandate/validateSISOExisting',
      validateUPIAgent: 'https://balicuat5.bajajlife.com/CCSI/mandate/validateAgentCode',
      getMandateConfig: 'https://balicuat5.bajajlife.com/CCSI/shortenedJourney/getConfig',
       //mandate value api
      mandateAuthToken: 'https://uat3.bajajlife.com/PhysicalNachWS/api/auth/generate-token',
      authCred:{
      "username" : "uatTesting",
      "password" : "testing@123"
      },
      channelDetails:(agentCode: any) => `https://uat3.bajajlife.com/PhysicalNachWS/fetch/channels/${agentCode}`
    },
  };

  // Getters to dynamically access URLs based on current environment


  public static get BaseUrl(): string {
    return this.config[this.CURRENT_ENV]?.BaseUrl || '';
  }

  public static get RAZORPAY_KEY(): string {
    return this.config[this.CURRENT_ENV]?.RAZORPAY_KEY || '';
  }

  public static get createCustomer(): string {
    return this.config[this.CURRENT_ENV]?.createCustomer || '';
  }

  public static get createCustomerUPI(): string {
    return this.config[this.CURRENT_ENV]?.createCustomerUPI || '';
  }

  public static get downTimeUrl(): string {
    return this.config[this.CURRENT_ENV]?.downTimeUrl || '';
  }

  public static get renPayModeChange(): string {
    return this.config[this.CURRENT_ENV]?.renPayModeChange || '';
  }

  public static get saveMandateSign(): string {
    return this.config[this.CURRENT_ENV]?.saveMandateSign || '';
  }

  public static get saveMandateSignUPI(): string {
    return this.config[this.CURRENT_ENV]?.saveMandateSignUPI || '';
  }

  public static get storeLogs(): string {
    return this.config[this.CURRENT_ENV]?.storeLogs || '';
  }

  public static get vendorType(): string {
    return this.config[this.CURRENT_ENV]?.vendorType || '';
  }

  public static get ccsi(): string {
    return this.config[this.CURRENT_ENV]?.ccsi || '';
  }

  public static get NRIccsiCallbackURL(): string {
    return this.config[this.CURRENT_ENV]?.NRIccsiCallbackURL || '';
  }

  public static get pgclCCSICallbackURL(): string {
    return this.config[this.CURRENT_ENV]?.pgclCCSICallbackURL || '';
  }

  public static get pgclNACHCallbackURL(): string {
    return this.config[this.CURRENT_ENV]?.pgclNACHCallbackURL || '';
  }

  public static get pgclUPICallbackURL(): string {
    return this.config[this.CURRENT_ENV]?.pgclUPICallbackURL || '';
  }

  public static get NRIccsi(): string {
    return this.config[this.CURRENT_ENV]?.NRIccsi || '';
  }

  public static get validateSISOExtisting(): string {
    return this.config[this.CURRENT_ENV]?.validateSISOExtisting || '';
  }

  public static get validateUPIAgent(): string {
    return this.config[this.CURRENT_ENV]?.validateUPIAgent || '';
  }

  public static get vendorTypeCCSI(): string {
    return this.config[this.CURRENT_ENV]?.vendorTypeCCSI || '';
  }

  public static get vendorTypeNACH(): string {
    return this.config[this.CURRENT_ENV]?.vendorTypeNACH || '';
  }

  public static get vendorTypeUPI(): string {
    return this.config[this.CURRENT_ENV]?.vendorTypeUPI || '';
  }

  public static get getMandateConfig(): string {
    return this.config[this.CURRENT_ENV]?.getMandateConfig || '';
  }
  public static get mandateAuthToken(): string {
    return this.config[this.CURRENT_ENV]?.mandateAuthToken || '';
  }
  public static get authCred(): any {
    return this.config[this.CURRENT_ENV]?.authCred || '';
  }
  public static channelDetails(code:any): any {
    return this.config[this.CURRENT_ENV]?.channelDetails(code) || '';
  }

  // Other fixed endpoint paths appended to BaseUrl

  public static get getFetchAutoData_NGIN(): string {
    return 'DocumentKycAPI/MandateService/getApplicationTrackerDetails';
  }

  public static get emandate_NGIN(): string {
    return 'CustomerPortal/emandate_new/GetClientData.jsp';
  }

  public static get enach_NGIN(): string {
    return 'CustomerPortal/enach_new/GetClientData.jsp';
  }

  public static get upiMandate_NGIN(): string {
    return 'CustomerPortal/UPIMandate_new/GetClientData.jsp';
  }

  public static get emandate(): string {
    return 'CustomerPortal/emandate/GetClientData.jsp';
  }

  public static get enach(): string {
    return 'CustomerPortal/enach/GetClientData.jsp';
  }

  public static get upiMandate(): string {
    return 'CustomerPortal/UPIMandate/GetClientData.jsp';
  }

  public static get checkPolicy(): string {
    return 'DocumentKycAPI/MandateService/application_routing_info';
  }

  public static get getFetchAutoData(): string {
    return 'OnlineCustomerPortal/ws/Prelogin/azbj_fetch_auto_data';
  }

  public static get getApplicationTracker(): string {
    return 'DocumentKycAPI/MandateService/getApplicationTrackerDetails';
  }

  public static get setNewCustomerData(): string {
    return 'OnlineCustomerPortal/ws/login/azbj_emandate_standalon_logs';
  }

  public static get setExistingCustomerData(): string {
    return 'OnlineCustomerPortal/ws/login/azbj_emandate_standalon_logs';
  }

  public static get getAllData(): string {
    return 'DocumentKycAPI/MandateService/validateOnlineRenewalService';
  }

  public static get getUniqueAppid(): string {
    return 'OnlineCustomerPortal/ws/Prelogin/azbj_return_unique_id';
  }

  public static get getdataGenericLink(): string {
    return 'OnlineCustomerPortal/ws/Prelogin/azbj_partners_mandate_reg';
  }

  public static get getPolicyDtlsOnGroupid(): string {
    return 'DocumentKycAPI/MandateService/groupIdDetailsForMRService';
  }
}
